import React from 'react';
import { Card } from '@/components/ui/card';
import { DEFAULT_TIME_SLOTS, BREAK_INDEXES } from './subjectColor';

export const HeatmapView = ({ days, periods, heatmapData, teachersCount }) => (
  <Card className="p-4 sm:p-6" data-testid="heatmap-view">
    <div className="mb-5">
      <h2 className="text-xl font-bold text-slate-900">School Occupancy Heatmap</h2>
      <p className="text-sm text-slate-500">Shows how many of {teachersCount} teachers are busy vs free per period. Darker = more teachers busy.</p>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full border-collapse" data-testid="heatmap-table">
        <thead>
          <tr>
            <th className="p-2.5 text-left text-xs font-semibold text-slate-500 uppercase border-b-2 border-slate-300 w-20">Period</th>
            <th className="p-2.5 text-left text-xs font-semibold text-slate-500 uppercase border-b-2 border-slate-300 w-16">Time</th>
            {days.map(day => (
              <th key={day} className="p-2.5 text-center text-xs font-semibold text-slate-700 uppercase border-b-2 border-slate-300" style={{ minWidth: '140px' }}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {periods.map((period, pIdx) => {
            const timeSlot = DEFAULT_TIME_SLOTS[pIdx] || '';
            const breakLabel = BREAK_INDEXES[pIdx];
            return (
              <React.Fragment key={period}>
                {breakLabel && (
                  <tr>
                    <td colSpan={2 + days.length} className="py-1">
                      <div className="h-px bg-slate-300 relative">
                        <span className="absolute left-1/2 -translate-x-1/2 -top-2.5 bg-white px-3 text-[10px] font-medium text-slate-400 uppercase tracking-wider">{breakLabel}</span>
                      </div>
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="p-2 text-sm font-medium text-slate-600 border-b border-slate-100">{period}</td>
                  <td className="p-2 text-xs text-slate-400 border-b border-slate-100">{timeSlot}</td>
                  {days.map(day => {
                    const data = heatmapData[`${day}-${period}`] || { busy: 0, free: 0, pct: 0 };
                    const intensity = data.pct;
                    const bgColor = intensity > 80 ? 'bg-red-500' : intensity > 60 ? 'bg-orange-400' : intensity > 40 ? 'bg-amber-300' : intensity > 20 ? 'bg-emerald-200' : 'bg-emerald-100';
                    const textColor = intensity > 60 ? 'text-white' : 'text-slate-800';
                    return (
                      <td key={day} className="p-1.5 border-b border-slate-100 border-l border-slate-50" style={{ minWidth: '140px' }}>
                        <div className={`px-3 py-3 rounded-lg ${bgColor} ${textColor} text-center transition-shadow hover:shadow-md`} data-testid={`heatmap-cell-${day.toLowerCase()}-p${pIdx + 1}`}>
                          <p className="text-lg font-bold">{data.busy}</p>
                          <p className="text-[10px] opacity-80">{data.busy} busy / {data.free} free</p>
                          <p className="text-[10px] font-semibold mt-0.5">{data.pct}% occupied</p>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
    <div className="flex items-center gap-3 mt-4 text-xs text-slate-500">
      <span>Occupancy:</span>
      <span className="flex items-center gap-1"><span className="w-4 h-3 rounded bg-emerald-100"></span>0-20%</span>
      <span className="flex items-center gap-1"><span className="w-4 h-3 rounded bg-emerald-200"></span>20-40%</span>
      <span className="flex items-center gap-1"><span className="w-4 h-3 rounded bg-amber-300"></span>40-60%</span>
      <span className="flex items-center gap-1"><span className="w-4 h-3 rounded bg-orange-400"></span>60-80%</span>
      <span className="flex items-center gap-1"><span className="w-4 h-3 rounded bg-red-500"></span>80%+</span>
    </div>
  </Card>
);
